import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/Motion";
import Seo from "@/components/Seo";
import { COURSES, IMAGES } from "@/data/content";

export default function Academy() {
  const main = COURSES.filter((c) => c.track === "principale");
  const compl = COURSES.filter((c) => c.track === "complementare");

  return (
    <div className="pt-24 pb-28 min-h-screen">
      <Seo title="Lux Academy — Formazione Akashica e Olistica" description="La Lux Academy: formazione sui Registri Akashici in tre livelli e percorsi complementari (sensitività, medianità, channeling, pranoterapia, cristalloterapia, meditazione). Online e in presenza." image={IMAGES.academy} />
      <div className="relative h-[60vh] min-h-[460px] overflow-hidden constellation">
        <img src={IMAGES.academy} alt="Lux Academy" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#F7EFE0] via-[#F7EFE0]/50 to-[#F7EFE0]/30" />
        <div className="absolute inset-0 max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col justify-center">
          <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Il cuore di Lux Aeterna</p>
          <h1 className="font-display text-5xl sm:text-7xl lg:text-[6rem] text-[#2A1F14] leading-[0.98]">LUX ACADEMY</h1>
          <p className="text-[#2A1F14]/60 text-lg max-w-2xl mt-8 leading-relaxed">Una prestigiosa accademia privata dedicata alla crescita personale e alla spiritualità contemporanea. Un catalogo che ruota attorno ai Registri Akashici.</p>
        </div>
      </div>

      {/* Percorso principale */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <Reveal><p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">Percorso principale</p>
          <h2 className="font-display text-4xl sm:text-5xl text-[#2A1F14] mb-14">I tre livelli dei Registri Akashici.</h2></Reveal>
        <Stagger className="grid lg:grid-cols-3 gap-5">
          {main.map((c, i) => (
            <StaggerItem key={c.slug}>
              <Link to={`/academy/${c.slug}`} data-testid={`course-${c.slug}`} className="block border border-[#2A1F14]/10 rounded-2xl p-8 h-full hover:border-gold/50 hover:bg-[#EFE3CE] transition-colors duration-500 group">
                <div className="flex justify-between items-start mb-8">
                  <span className="font-display text-5xl text-gold/30 group-hover:text-gold transition-colors">0{i + 1}</span>
                  <GraduationCap className="text-[#2A1F14]/30 group-hover:text-gold transition-colors" size={22} />
                </div>
                <p className="text-[10px] uppercase tracking-[0.2em] text-gold mb-2">{c.level}</p>
                <h3 className="font-display text-2xl text-[#2A1F14] mb-3">{c.title}</h3>
                <p className="text-[#2A1F14]/50 text-sm leading-relaxed mb-6">{c.tagline}</p>
                <p className="text-[#2A1F14]/35 text-xs mb-6">{c.duration}</p>
                <span className="text-[#2A1F14]/40 group-hover:text-gold transition-colors inline-flex items-center gap-2 text-sm">Scopri il corso <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></span>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      {/* Percorsi complementari */}
      <section className="bg-[#EFE3CE] py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">Percorsi complementari</p>
            <h2 className="font-display text-4xl sm:text-5xl text-[#2A1F14] mb-14">Espandi le tue capacità.</h2></Reveal>
          <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {compl.map((c) => (
              <StaggerItem key={c.slug}>
                <Link to={`/academy/${c.slug}`} data-testid={`course-${c.slug}`} className="block glass rounded-xl p-7 h-full hover:border-gold/40 transition-colors duration-500 group">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-gold mb-3">{c.level}</p>
                  <h3 className="font-display text-xl text-[#2A1F14] mb-2">{c.title}</h3>
                  <p className="text-[#2A1F14]/45 text-sm mb-5">{c.tagline}</p>
                  <div className="flex gap-2">
                    {c.modes.map((m) => <span key={m} className="text-[10px] uppercase tracking-wide text-[#2A1F14]/40 border border-[#2A1F14]/15 rounded-full px-3 py-1">{m}</span>)}
                  </div>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
